import React, { useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import InnerPageLayout from "../components/Layout/InnerPageLayout";
import BreadCrumb from "../components/Breadcrumb/BreadCrumb";
import BlogDetailsInfo from "../components/BlogInfo/BlogDetailsInfo";
import { useContentAvailability } from "../utils/contentAvailability";

export default function BlogDetails() {
  const { hasBlogs } = useContentAvailability();
  const { slug } = useParams();
  const [blogTitle, setBlogTitle] = useState("Blog Details");

  // Callback to receive blog title from child component
  const handleBlogLoaded = useCallback((title) => {
    setBlogTitle(title);
  }, []);

  // Return null if blogs are not available
  if (!hasBlogs) {
    return null;
  }
  
  return (
    <InnerPageLayout>
      <BreadCrumb 
        pageTitle={blogTitle}
        items={[
          { label: "Blogs", path: "/blogs" },
          { label: blogTitle, path: `/blog/${slug}` }
        ]}
      />
      <BlogDetailsInfo onBlogLoaded={handleBlogLoaded} />
    </InnerPageLayout>
  );
}
